import Vue from 'vue'
import App from './App.vue'
import router from '@/router';
import store from '@/store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from '@/locales/elementUI/ja.js'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret, faEye, faLock, faUser, faMousePointer, faSquare, faTimesCircle, faWindowClose, faAngleLeft, faAngleRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import '@/assets/tailwind.css'
import "tailwindcss/tailwind.css"
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import VuePapaParse from 'vue-papa-parse'
import VueCookies from 'vue-cookies'
import { configSquareType } from "@/config/squareType";

Vue.use(VueCookies, { expire: '3d'})

library.add(faPlus, faUserSecret, faEye, faLock, faUser, faMousePointer, faSquare, faTimesCircle, faWindowClose, faAngleLeft, faAngleRight);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import JsonCSV from 'vue-json-csv';
Vue.component('downloadCsv', JsonCSV);

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });

// setup rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
Vue.use(VuePapaParse)

import VueKonva from 'vue-konva';
Vue.use(VueKonva);

import moment from 'moment';
Vue.prototype.$moment = moment;

extend('min', {
  validate(value, { length }) {
    return value.length >= length;
  },
  params: ['length'],
  message: '{_field_}{length}~20文字を入力してください。'
});

extend('min_number', {
  validate(value, { length }) {
    return Number(value) >= length || Number(value) === 0;
  },
  params: ['length'],
  message: 'セル数は0または2以上を入力してください。'
});


extend('max', {
  validate(value, { length }) {
    return value.length <= length;
  },
  params: ['length'],
  message: '{_field_}8~{length}文字を入力してください。'
});
extend('maxValue', {
  validate(value, { length }) {
    return value.length <= length;
  },
  params: ['length'],
  message: '{_field_}{length}文字以下にしてください。'
});

extend('email', {
  message: '有効なメールアドレスを入力してください。'
});

extend('required', {
  message: '{_field_}を入力してください。'
});
extend('confirmed', {
  message: '新しいパスワードと新しいパスワード確認が一致しません'
});

extend('titleUnique', {
  validate(value, args) {
    if(args.arrObject && !Array.isArray(args.arrObject)){
      return true;
    }
    const foundArr = args.arrObject.filter(obj => obj.title === value && !obj.is_delete);


    const dataCheck = foundArr.find(obj => obj.title === value && ![configSquareType.rounded, configSquareType.checked].includes(Number(obj.box_type)))

    return foundArr.length === 1 || (foundArr.length >= 1 && [configSquareType.rounded, configSquareType.checked].includes(Number(args.type)) && !dataCheck);
  },
  params: ['arrObject', "type"],
  message: '項目名が重複しています。'
});

// setup components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

new Vue({
  router: router,
  store: store,
  render: h => h(App),
}).$mount('#app')
